const productTypeGroups = {
  makeup: 'Makeup',
  homeFragrance: 'HomeFragrance',
  perfume: 'Perfume',
  bathBody: 'BathBody', // skincare && wellness
  skincare: 'BathBody',
  personalCare: 'PersonalCare',
  perfumeCase: 'PerfumeCase',
  candleSet: 'CandleSet',
  fragranceStorageBox: 'FragranceStorageBox',
  perfumeOfTheMonth: 'PerfumeOfTheMonth',
}


export default productTypeGroups
